import styled from 'styled-components';
import { setRem } from '../../utils/styles';

export const PageTitle = styled.h1`
  padding: ${setRem(25)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const Container = styled.div`
  display: flex;
  height: calc(100% - ${setRem(38)} - ${setRem(25)});
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const Sidebar = styled.div`
  flex: 28.5% 1 0;
  padding-left: ${setRem(50)};
`;

export const SidebarContent = styled.div`
  margin-bottom: 48px;
`;

export const SidebarImage = styled.img`
  width: 100%;
  height: auto;
  max-height: ${setRem(250)};
  max-width: ${setRem(250)};
`;

export const Main = styled.div`
  flex: 44% 1 0;
  padding: 0 12.4% 0 10.37%;
  overflow-y: scroll;
`;
